import { all, takeLatest } from 'redux-saga/effects'

import metaTypes from '~/state/firebase/metaTypes'

import firebaseListener from './workers/firebaseListener'

export default function* root() {
  yield all([firebaseListener(metaTypes.labels)])
}
